import { takeLatest, put, call, select } from 'redux-saga/effects';
import { SUBMIT_COMMENT_REQUEST, submitCommentSuccess, submitCommentFailure } from '../actions/comments';
import { postComment } from '../services/comments';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { setHistorical } from '../actions/historical';
import { historicalSelector } from '../selectors/historical';
import { buildHistory } from '../helpers/historical';

const submitCommentsWorker = function*({ payload: { ticket_id, comment } }) {
    try {
        const token = yield select(accessTokenSelector);
        const { data } = yield call(postComment, ticket_id, { comment }, token);
        yield put(submitCommentSuccess(data));

        const { historical } = yield select(historicalSelector);

        const gotToday = historical.find(groupHistories => groupHistories.displayDate === '[TODAY]');

        if (gotToday) {
            const groupHistories = {
                ...gotToday,
                histories: [
                    buildHistory({
                        user: { data: {} },
                        date: new Date(),
                        modification: [
                            {
                                field: 'comment',
                                value: comment
                            }
                        ]
                    }),
                    ...gotToday.histories.filter(history => history.type !== 'comment')
                ]
            };

            yield put(setHistorical([groupHistories, ...historical.filter(group => group.displayDate !== '[TODAY]')]));
        } else {
            const groupHistories = {
                displayDate: '[TODAY]',
                histories: [
                    buildHistory({
                        user: { data: {} },
                        date: new Date(),
                        modification: [
                            {
                                field: 'comment',
                                value: comment
                            }
                        ]
                    })
                ]
            };

            yield put(setHistorical([groupHistories, ...historical]));
        }
    } catch (err) {
        yield put(submitCommentFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [takeLatest(SUBMIT_COMMENT_REQUEST, submitCommentsWorker)];
